import React, { ReactElement } from 'react'
import CardActions from '@mui/material/CardActions'
import Button from '@mui/material/Button'
import { ButtonProps } from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Skeleton from '@mui/material/Skeleton';

interface Props {
    buttons: Buttons[]
    loading?: boolean
}
interface Buttons extends ButtonProps {
    label: string | ReactElement
}
const AvatarButtons: React.FC<Props> = React.memo(function AvatarButtons(props: Props) {
  if (props.loading) {
    return (
        <Stack style={{width: '100%', justifyContent: 'end', paddingTop: '10px'}} direction="row" spacing={1}>
            <Skeleton variant="rectangular" width={100} height={35} />
            <Skeleton variant="rectangular" width={100} height={35} />
        </Stack>
    )
  }
  return (
    <CardActions sx={{ justifyContent: 'end' }}>
        {
            props.buttons && props.buttons.map((btn, idx) => 
                <Button key={idx} {...btn}>
                  {btn.label}
                </Button>
            )
        }
      </CardActions>
  )
})

export default AvatarButtons
